<div
    class="anc-field anc-field--time"
    [class.anc-field--floating]="floating()"
    [class.anc-field--focused]="focused()"
    [class.anc-field--readonly]="readonly()"
>
    @if (control(); as ctrl) {
        <input
            class="form-control"
            [formControl]="ctrl"
            [type]="inputType()"
            [readonly]="readonly()"
            [attr.aria-label]="label() | translate"
            autocomplete="off"
            ancFieldValidate
            [ancFieldValidateSubmitted]="validateSubmitted()"
            [ancFieldValidateForceInvalid]="forceInvalid()"
            (focus)="onFocus()"
            (blur)="onBlur()"
        />
    }
    @if (label()) {
        <label class="anc-field__label" translate
            >{{ label() }}<sup class="super-star" *ngIf="required()">*</sup></label
        >
    }
    <!-- Resting state renders a text input, so show the clock the native
    time input would; it hides once the native input (with its own) takes over. -->
    @if (!floating()) {
        <i class="icon icon-clock anc-field__time-icon" aria-hidden="true"></i>
    }
    @if (showRequiredError()) {
        <div ancError>
            <div class="has-error" translate>{{ requiredErrorMessage() }}</div>
        </div>
    }
    <ng-content select="[ancError]"></ng-content>
</div>
